import {io} from "socket.io-client";
import { URLS } from "../apiService";

let socket;

export const connectSocket = () => {
    const token = localStorage.getItem("authToken");

    if (!token || typeof token !== "string") {
        console.error(" Invalid token:", token);
        return;
    }

    if (socket?.connected) return socket;

    const SOCKET_URL = URLS.notification_socket;
    console.log(" SOCKET URL::::::", SOCKET_URL);

    socket = io(SOCKET_URL, {
        path: "/api-notification/ws-notification",
        transports: ["websocket"],
        reconnection: true,
        reconnectionAttempts: 20,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 10000,
        randomizationFactor: 0.5,
        timeout: 10000,
        query: {token},
    });

    console.log(" TOKEN SENT:", token);

    socket.on("connect", () => {
        console.log(" Socket connected:", socket.id);
    });

    socket.on("connect_error", (err) => {
        console.error(" Socket error:", err.message);
    });

    return socket;
};

export const getSocket = () => socket;

export const disconnectSocket = () => {
    if (socket) {
        socket.removeAllListeners();
        socket.disconnect();
        socket = null;
        console.log("Socket disconnected");
    }
};
